angular.module("app").directive("autocompleteSuggestions", [
    function () {
        return {
            replace: true,
            templateUrl: "",
            scope: {
                autocompleteSuggestions: "="
            },
            link: function ($scope, element, attrs) {
                attrs.$observe("watchFor", function (newVal, oldVal) {

                });




            }
        }
    }
]);